const triggerRouterCreateSession = (country, language) => {
  let sessionAndClientIp = getSessionAndClientIpFromCookies()
  if(sessionAndClientIp.sessionId && sessionAndClientIp.clientIp){
    return Promise.resolve(sessionAndClientIp)
  }
  const headersCreateSession = new Headers();
  const countryUpperCase = country.toUpperCase();
  headersCreateSession.append("x-wu-operationname", "createSession");
  headersCreateSession.append("Content-Type", "application/json");
  headersCreateSession.append("x-wu-accesscode", "RtYV3XDz9EA");
  headersCreateSession.append("wucountrycode", countryUpperCase);
  headersCreateSession.append("wulanguagecode", language);
  const blackBoxString =  window.sessionStorage.getItem('blackBoxString');
  
  let createSessionInput = {
    "businessMode": "DIGITAL",
    "externalReferenceNo": "1",
    "locale": {
      "countryCode": countryUpperCase,
      "languageCode": language
    },
    "security": {
      "requestHeader": [{
        "key": "isRREnabled",
        "value": "false"
      }],
      blackBoxData: {
        id: "101569194",
       ...(blackBoxString && {
          data: blackBoxString
        }),
        length: blackBoxString?.length ? `${blackBoxString?.length.toString()}` : '0'
      }
    },
    "device": {
      "type": "WEB"
    },
    "channel": {
      "type": "WEB",
      "name": "Western Union",
      "version": "9Z00",
      "isResponsive": "true",
      "deviceIdentifier": "RESPONSIVE_WEB"
    }
  }

  if(isPartnerIdEnabled(countryUpperCase)){
    const partnerId = getPartnerIdForCountry[countryUpperCase].webPartnerId;
    partnerId ? createSessionInput.channel["partnerId"] = partnerId : null
  }
  
  const graphql = JSON.stringify({
    query: createSessionQuery,
    variables: {
      req: createSessionInput
    }
  })
  const requestOptions = {
    method: 'POST',
    headers: headersCreateSession,
    body: graphql,
    redirect: 'follow'
  };

  return fetchApiWu(routerUrl, requestOptions, 'createSessionVulcan')
    .then(result => {
      const obj = {
        sessionId: result?.data?.createSession?.security?.session?.id,
        encryptedSessionId: result?.data?.createSession?.security?.session?.encryptedSessionId,
        clientIp : result?.data?.createSession?.security?.clientIp,
        dataCenter : result?.data?.createSession?.security?.dataCenter
      }
      setCookieOnCreateSessionResponse(obj);
      return Promise.resolve(obj)
    })
    .catch(error => console.log('Product Data not found: ', error));

}